// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"599":"17415d2b","5036":"64adcbc8","5749":"79f31df9","5913":"64adcbc8","7894":"84f253cf","8069":"8ff8fc1f","9408":"35f7c8a6"}[chunkId] + ".chunk.css";
};